export default __webpack_public_path__ + "media/images/manual/ic/02-555524c2648257dc03d8c3816aefc056.png";